import { Badge, Modal } from "flowbite-react";
import { useContext } from "react";
import { IAppContextState, AppContext } from "../../../App";
import { Link } from "react-router-dom";
import { HaziraImageGallery } from "../../../components/image-gallery/hazira-gallery";

export const HaziraModalData = () => {
  const { haziraModalState } = useContext<IAppContextState | any>(AppContext);
  const [isOpenHaziraModal, setOpenHaziraModal] = haziraModalState;
  return (
    <Modal
      size={"5xl"}
      position={"top-center"}
      show={isOpenHaziraModal}
      onClose={() => setOpenHaziraModal(false)}
    >
      <Modal.Header>Hazira Web</Modal.Header>
      <Modal.Body>
        <div className="flex flex-wrap">
          <div className="md:w-[50%] w-full pe-2">
            <HaziraImageGallery />
          </div>
          <div className="md:w-[50%] w-full ps-2 md:mt-0 mt-6 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-xl">
                Project name: <span className="text-green-500">Hazira</span>
              </h3>
              <p className="mt-4 mb-2 text-md text-[15px]">Tech used:</p>
              <div className="flex">
                <Badge color="red" className="me-2 my-1">
                  Angular
                </Badge>
                <Badge color="blue" className="me-2 my-1">
                  Bootstrap
                </Badge>
                <Badge color="pink" className="my-1">
                  SCSS
                </Badge>
              </div>
              <div className="mt-5 mb-2 ">
                <p className="font-semibold">Description:</p>
                <div className="text-[15px]">
                  <p>
                    Smart management of human resources can be a game changer
                    for the success of your business. Leave this crucial task in
                    the capable hands of 'Hazira' with complete confidence!
                  </p>
                  <ul className="list-disc mt-4 ms-5">
                    <li>I worked on this project during my working period.</li>
                    <li>
                      The whole UI is developed with Bootstrap Custom theming.
                    </li>
                    <li>This app is fully mobile responsive.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://app.hazira.com/"
                className="text-green-500 hover:text-green-600 hover:underline me-4"
              >
                Go to Hazira Web
              </Link>
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://app.teamrail.io/"
                className="text-orange-500 hover:text-orange-600 hover:underline"
              >
                Go to Teamrail Web
              </Link>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
